<template>
  <div>
    <i
      class="fa-solid fa-circle-plus dialog"
      @click="
        visible = true;
        fetch_country();
        fetch_supplier_types();
      "
    ></i>
    <Dialog
      v-model:visible="visible"
      modal
      header="Edit Profile"
      :dismissableMask="true"
    >
      <add-supplier @closrDilaog="closrDilaog" />
    </Dialog>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
// import Multiselect from "vue-multiselect";
import Dialog from "primevue/dialog";
import addSupplier from "@/components/suppliers/addSupplier.vue";
export default {
  name: "add-suppliers",
  emits: ["supplierAdded"],
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      address: "",
      countryValues: "",
      countries: [],
      supplier_type_value: {
        id: "",
        title: "",
      },
      supplier_types: [],
      credit_limit: 0, // Initialize as an empty string to store the selected option
      down_payment: 0,
      payment_method: 1,
      tax_number: "",
      registration_number: "",
      paids: [
        {
          id: 1,
          title: this.$t("treasury"),
        },
        {
          id: 2,
          title: this.$t("bank"),
        },
        {
          id: 3,
          title: this.$t("ewalllets"),
        },
        {
          id: 4,
          title: this.$t("checks_under_collection"),
        },
      ],
      accountValue: "",
      paidValues: "",
      accounts: [],
      account_number: "",
      bank_name: "",
      IBAN: "",
      visible: false,
    };
  },
  components: {
    // Multiselect,
    Dialog,
    addSupplier,
  },
  methods: {
    closrDilaog(data) {
      this.visible = data;
    },
    addsupplier() {
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("address", this.address);
      formData.append("country_id", this.countryValues);
      formData.append("role", 2);
      formData.append("credit_limit", this.credit_limit);
      formData.append("bank_name", this.bank_name);
      formData.append("Iban", this.IBAN);
      formData.append("bank_number", this.account_number);
      formData.append("supplier_type_id", this.supplier_type_value.id);
      if (this.payment_method == 2) {
        formData.append("Pending_limit", this.credit_limit);
      }
      if (this.payment_method == 3) {
        formData.append("prepayment_amount", this.down_payment);
      }

      formData.append(`payment_method`, this.payment_method);
      if (this.accountValue) {
        formData.append(`safe_branch_id`, this.accountValue);
      }
      if (this.client_type == 2) {
        formData.append("registration_number", this.registration_number);
        formData.append("tax_number", this.tax_number);
      }
      axios
        .post("/consumers", formData)
        .then(({ data }) => {
          this.visible = !this.visible;
          Swal.fire({
            title: "",
            text: data.message,
            icon: "success",
          });
          this.$emit("supplierAdded");
        })
        .catch((error) => {
          this.visible = !this.visible;
          Swal.fire({
            title: "",
            text: error.response.data.message,
            icon: "error",
          });
        });
    },
    fetch_supplier_types() {
      axios.get("/supplier_types").then(({ data }) => {
        this.supplier_types = data.data.data;
      });
    },
    //fetch country
    fetch_country() {
      axios.post("/fetch_countries").then(({ data }) => {
        this.countries = data.data;
        // console.log(this.countries);
      });
    },
    FetchAccounts(account_id) {
      let type = { payment_method: account_id };
      axios.post(`/fetch_payment_method`, type).then(({ data }) => {
        this.accounts = data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/view/dashboard/suppliers/_suppliers.scss";
form {
  label {
    display: inline-block;
    margin-bottom: 10px;
    font-family: "bold" !important;
  }
  input,
  select {
    display: block;
    width: 100%;
    // height: 68px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
    color: #9ca2ac;
    padding: 10px 15px;
  }
}
.form-check-inline {
  display: inline-flex;
  flex-direction: column;
  margin-top: 0;
}
.form-check-input {
  width: 17px;
  height: 17px;
  padding: 0;
}
i.fa-solid.fa-circle-plus.dialog {
  cursor: pointer;
  position: initial;
}
</style>
